module.exports = __webpack_public_path__ + "img/powerd-avalanche.20dba735.png";